/**
 * @file Hook that tells us if compose is open
 */
import { useLocation } from 'react-router-dom';

import { getSearchParamCompose } from '../../../routes/helpers/searchParams';

/**
 * Hook that tells us if compose is open
 * based on url
 *
 * @returns Whether the compose is open
 */
const useIsComposeOpen = (): boolean => {
  const location = useLocation();

  const isOpen = getSearchParamCompose(location) !== null;

  return isOpen;
};

export default useIsComposeOpen;
